import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ScrollWatcherDirective } from './';

@NgModule({
  declarations: [
    ScrollWatcherDirective,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    CommonModule,
    ScrollWatcherDirective,
  ],
})
export class ScrollWatcherModule {}
